import React from "react";
import styles from "./navbar.module.css";
import ThreeLine from "../static/images/component_svg/ThreeLine.svg";
import correct from "../static/images/component_svg/correct.svg";
import star from "../static/images/component_svg/starwhite.svg";
import sorsorsor from "../static/images/component_pic/sorsorsor.png";
import thaihealth from "../static/images/component_pic/logo-thaihealth.png";

function Navbar({ index }) {
  const number = index - 2;
  const list1 = [1, 2, 3, 4, 5, 6].slice(0, number);
  const list2 = [1, 2, 3, 4, 5, 6].slice(number);

  return (
    <nav className={styles.nav}>
      <div className={styles.navhead}>
        {/* <img className={styles.three} src={ThreeLine} alt="Threeline"></img> */}
        <div className={styles.text}>เกมทดสอบทักษะสมอง</div>
        <a
          href="https://creativehealthcampaign.thaihealth.or.th/microsite/healthyfamily/Inclusive/%E0%B8%AA%E0%B8%B9%E0%B8%87%E0%B8%A7%E0%B8%B1%E0%B8%A2%E0%B9%83%E0%B8%AB%E0%B9%89%E0%B8%9E%E0%B8%A3%E0%B9%89%E0%B8%AD%E0%B8%A1%E0%B8%81%E0%B9%88%E0%B8%AD%E0%B8%9940/content/4385"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.pic}
        >
          <img className={styles.thaihealth} src={thaihealth} alt="40plus" />
          <img className={styles.sorsorsor} src={sorsorsor} alt="40plus" />
        </a>
      </div>
      {number > 0 && number < 6 && (
        <div className={styles.navbody}>
          <div className={styles.rowline}>
            {list1.map((num, index) => (
              <div className={styles.rowline} key={index}>
                {number === num ? (
                  <div className={styles.stagebody}>
                    <div className={styles.stage}>{number}</div>
                    <div
                      className={
                        index === 0
                          ? styles.trianglebodyfirst
                          : styles.trianglebody
                      }
                    >
                      <div
                        className={
                          index === 0 ? styles.trianglefirst : styles.triangle
                        }
                      ></div>
                      <div className={styles.greentext}>
                        {" "}
                        {num !== 6 ? `เกมทดสอบ ${num}/5` : `ผลการทดสอบ`}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className={styles.correct}>
                    <img src={correct} alt="correct"></img>
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className={styles.line}></div>

          <div className={styles.rowline}>
            {list2.map((num, index) => (
              <div className={styles.correctblur} key={index}>
                {num !== 6 ? (
                  num
                ) : (
                  <img src={star} alt="star" className={styles.staricon} />
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
